export default "__VITE_ASSET__CWmhVqJo__"